var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-calendar-components"},[(_vm.isLoading)?_c('Loader'):_vm._e(),_vm._v(" "),_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}}),_vm._v(" "),(_vm.showModal)?_c('Modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }